import qs from 'qs';

/**
 * Helper function that converts a query param like object to its string representation.
 */
export const stringifyQueryParams = (params: object) => qs.stringify(params, { arrayFormat: 'repeat' });
